import { useFetch, useSnackbar } from "../../../hooks";

import { BACKEND_ROUTES } from "../../../backendRoutes";
import { ConfirmModal } from "../../../components/ConfirmModal";
import { LoadingButton } from "@mui/lab";
import { MODEL_PROPTYPES } from "../../../models";
import { PIPELINE_INSTANCE_STATUS } from "../../../constants";
import PropTypes from "prop-types";
import { Stop } from "@mui/icons-material";
import { useState } from "react";

AbortButton.propTypes = {
    pipelineInstance: PropTypes.shape(MODEL_PROPTYPES.PipelineInstance)
        .isRequired,
    mutate: PropTypes.func.isRequired,
};

export function AbortButton({ pipelineInstance, mutate }) {
    const { post } = useFetch();
    const { openSnackbar } = useSnackbar();

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const isAbortable =
        pipelineInstance.status === PIPELINE_INSTANCE_STATUS.ONGOING ||
        pipelineInstance.status === PIPELINE_INSTANCE_STATUS.PLANNED ||
        pipelineInstance.status === PIPELINE_INSTANCE_STATUS.SUSPENDED;

    if (!isAbortable) return null;

    const handleAbort = async () => {
        setIsLoading(true);
        setIsDialogOpen(false);
        try {
            await post(
                `${BACKEND_ROUTES.PIPELINE_INSTANCE}/${pipelineInstance.uuid}/abort`,
                { forwardError: true }
            );
            openSnackbar("Pipeline instance aborted successfully", "success");
            mutate();
        } catch (error) {
            openSnackbar(
                error.message || "Failed to abort pipeline instance",
                "error"
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <LoadingButton
                variant="outlined"
                color="error"
                startIcon={<Stop />}
                onClick={() => setIsDialogOpen(true)}
                loading={isLoading}
            >
                Abort
            </LoadingButton>
            <ConfirmModal
                isOpen={isDialogOpen}
                onCancel={() => setIsDialogOpen(false)}
                onConfirm={handleAbort}
                title="Abort Pipeline Instance"
                contentText="Are you sure you want to abort this pipeline instance? This action cannot be undone. All jobs that are ongoing or planned will be canceled."
            />
        </>
    );
}
